import React from 'react';

import Photo from './photo';

class Grid extends React.Component {
  render() {
    const { posts } = this.props;
    return (
      <div>
        <h1>Grid</h1>
        {posts.map((post, index) => <Photo key={index} index={index} {...this.props} post={post} />)}
      </div>
    )
  }
};

export default Grid;



// WEBPACK FOOTER //
// ./src/components/photogram/grid.js